if (!customElements.get('product-form')) {
  function __dhqNormalizeVariantId(v) {
    if (v == null) return '';
    const s = String(v);
    if (s.includes('gid://shopify/ProductVariant/')) {
      return s.replace('gid://shopify/ProductVariant/', '').split('_')[0];
    }
    return s.split('_')[0];
  }

  function __dhqReadSolitaireSelection(variantId) {
    try {
      const vid = __dhqNormalizeVariantId(variantId);
      if (!vid || !window.localStorage) return null;
      const raw = window.localStorage.getItem('dhq_solitaire_selection_' + String(vid));
      if (!raw) return null;
      const arr = JSON.parse(raw);
      return Array.isArray(arr) && arr.length ? arr : null;
    } catch (e) {
      return null;
    }
  }

  function __dhqFormDataHas(fd, key) {
    try {
      if (typeof fd.has === 'function') return fd.has(key);
      return fd.get(key) != null;
    } catch (e) {
      return false;
    }
  }

  function __dhqAppendSolitairePropertiesToFormData(formData, variantId) {
    const arr = __dhqReadSolitaireSelection(variantId);
    if (!Array.isArray(arr) || !arr.length) return;

    for (const s of arr) {
      if (!s) continue;
      const idx = Number(s.index);
      if (!Number.isFinite(idx)) continue;
      if (s.color == null || s.clarity == null || s.shape == null || s.carat == null || s.diamondId == null || s.price == null) continue;

      const pairs = [
        [`properties[_solitaire_${idx}_color]`, String(s.color)],
        [`properties[_solitaire_${idx}_clarity]`, String(s.clarity)],
        [`properties[_solitaire_${idx}_shape]`, String(s.shape)],
        [`properties[_solitaire_${idx}_carat]`, String(s.carat)],
        [`properties[_solitaire_${idx}_diamond id]`, String(s.diamondId)],
        [`properties[_solitaire_${idx}_price]`, String(s.price)],
        [`properties[_solitaire_${idx}_index]`, String(idx)]
      ];

      if (s.cut != null && String(s.cut).trim() !== '') pairs.push([`properties[_solitaire_${idx}_cut]`, String(s.cut)]);
      if (s.fluorescence != null && String(s.fluorescence).trim() !== '') pairs.push([`properties[_solitaire_${idx}_fluorescence]`, String(s.fluorescence)]);

      const certType = (s.certificateType != null ? s.certificateType : (s.lab != null ? s.lab : null));
      if (certType != null && String(certType).trim() !== '') pairs.push([`properties[_solitaire_${idx}_certificatetype]`, String(certType)]);

      const certNumber = (s.certificateNumber != null ? s.certificateNumber : (s.certificate_number != null ? s.certificate_number : (s.cert_num != null ? s.cert_num : null)));
      if (certNumber != null && String(certNumber).trim() !== '') {
        pairs.push([`properties[_solitaire_${idx}_certificatenumber]`, String(certNumber)]);
        pairs.push([`properties[_solitaire_${idx}_certificate_number]`, String(certNumber)]);
      }

      for (const [k, v] of pairs) {
        if (!__dhqFormDataHas(formData, k)) formData.append(k, v);
      }
    }
  }

  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        formData.append('properties[size]', '1');

        // Ensure custom solitaire selection persists even for AJAX add-to-cart.
        // This uses the localStorage backup written by the selector snippet.
        __dhqAppendSolitairePropertiesToFormData(formData, formData.get('id'));

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
